import React, { Component } from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { path } from 'ramda';
import Breadcrumbs from '../../common/Breadcrumbs';
import Table from '../../сomponents/Table';
import Preloader from "../../common/Preloader";
import { fetchAllEmployees, deleteEmployee, format_ss_no } from '../../api/employees';
import hasAccess from "../../helpers/permissionChecker";
import ClickOutsideContainer from '../../сomponents/ClickOutsideContainer';
import FieldsOptions from './fieldsOptions';
import { mergeFields } from './fields';
import { changeModalState } from '../../actions/modal';
import { deleteObject } from '../../actions/objectToDelete';
import ConfirmAction from '../../common/ConfirmAction';
import { fetchCountries, fetchStates } from '../../api/geo';
import './style.css';

export class Employees extends Component {
    constructor(props) {
        super(props);
        this.onSearch = this.onSearch.bind(this);
        this.addEmployee = this.addEmployee.bind(this);
        this.onChangeItemsPerPage = this.onChangeItemsPerPage.bind(this);
        this.onChangeCurrentPage = this.onChangeCurrentPage.bind(this);
        this.openDialog = this.openDialog.bind(this);
        this.closeDialog = this.closeDialog.bind(this);
        this.handlerEdit = this.handlerEdit.bind(this);
        this.handlerDelete = this.handlerDelete.bind(this);

        this.state = {
            search: '',
            itemsPerPage: 10,
            loading: true,
            currentPage: 0,
            isOptionsDialogOpen: false
        };
    }

    onChangeItemsPerPage(e) {
        e.preventDefault();
        this.setState({
          itemsPerPage: e.target.value,
        });
        return false;
    }    

    onChangeCurrentPage(currentPage) {
        this.setState({
            currentPage: currentPage,
        });
    }

    addEmployee() {
        this.props.moveToAdd();
    }

    onSearch(e) {
        e.preventDefault();
        this.setState({
          search: e.target.value,
        });
        return false;
    }

    openDialog(evt) { 
      evt.preventDefault();
      evt.stopPropagation();
      this.setState({ isOptionsDialogOpen: true });
    }

    closeDialog(evt) { 
      if (!evt || evt.target.className.indexOf('field_options_button') === -1) {
        this.setState({ isOptionsDialogOpen: false });
      }
    }

    handlerDelete(id) {
      this.props.handleObjectToDelete({
        id: parseInt(id),
        handler: deleteEmployee,
      });
  
      this.props.handleModalState({
        isOpen: !this.props.modal.isOpen,
        modalId: 'deleteEmployee',
      });
    }

    handlerEdit(id) {
      this.props.moveToEdit(id);
    }

    componentDidUpdate() {
        const itemsList = path(['employees', 'list'], this.props);
        const { loading } = this.state;
        if (loading && itemsList) {
          this.setState({ loading: false });
        }
    }

    componentWillMount() {
        this.props.list();
    }
      
    render() {
        const itemsList = path(['employees', 'list'], this.props) || [];
        const fields = path(['employees', 'fields'], this.props);
        const visibleFields = fields ? fields.filter(f => f.display === 1) : [];

        const { loading, isOptionsDialogOpen } = this.state;

        const itemActions = {
          edit: {
            handler: this.handlerEdit,
            icon: ['fa fa-circle-thin icon-stack-3x', 'fa fa-pencil icon-stack-1x'],
            permission: { 'permAreaKey': 'employee', 'permTypeKey': 'edit' },
            iconClass: '',
            context: this,
            hasWrapper: true,
            title: 'edit',
          },
          delete: {
            handler: this.handlerDelete,
            authorColumnName: 'employee_id',
            permission: { 'permAreaKey': 'employee', 'permTypeKey': 'delete' },
            icon: ['fa fa-circle-thin icon-stack-3x', 'fa fa-times icon-stack-1x'],
            iconClass: '',
            context: this,
            hasWrapper: true,
            title: 'delete',
          }
        };

        const mainPart = loading ? <Preloader show={true} type='circle'/> :
        <Table
          items={itemsList}
          columns={[...visibleFields.map(f => f.name)]}
          columnNames={[...visibleFields.map(f => f.title), '']}
          markColumnWithClassName={true}
          itemsPerPage={this.state.itemsPerPage}
          search={this.state.search}
          actions={itemActions}
          onSearch={this.onSearch}
          onChangeItemsPerPage={this.onChangeItemsPerPage}
          currentPage={this.state.currentPage}
          onChangeCurrentPage={this.onChangeCurrentPage}
          wrapTableInDiv={true}
        />;
      return (
        <div style={{ paddingBottom: '25px' }}>
          <Breadcrumbs list={[
            { url: '/pages/dashboards', icon: 'dashboard', name: 'Dashboard' },
            { icon: 'people', name: 'Employees' },
          ]}/>
          <div className="card rounded">
            <div className="card-header rounded-top">
              Employees
            </div>
            <div className="card-block">
              {hasAccess({ 'permAreaKey': 'employee', 'permTypeKey': 'create' }) &&
              <div className="clearfix mb-3">
                <button className="btn btn-rounded btn-icon ui-btn pull-right field_options_button" onClick={this.openDialog}>
                  <i className="material-icons">settings</i>
                  <span className="color-default">Change Fields</span>
                </button>

                <button className="btn btn-rounded btn-icon ui-btn pull-right" onClick={this.addEmployee}>
                  <i className="material-icons">add_circle_outline</i>
                  <span className="color-default">Add</span>
                </button>

                {isOptionsDialogOpen && 
                  <ClickOutsideContainer
                    onClickOutside={this.closeDialog}
                    skipClickOutsideWhen={this.skipCloseWhen}>
                    <FieldsOptions onComplete={this.closeDialog} />
                  </ClickOutsideContainer>}
              </div>
              }
              {mainPart}
              <ConfirmAction id={'deleteEmployee'}/>
            </div>
          </div>
        </div>
      );
    }

}

const mapStateToProps = (state) => {
    return state;
};

const mapDispatchToProps = (dispatch) => {

    const parse = (action, countries) => {
      const fields = action.payload && action.payload.fields ? action.payload.fields : null;
      if (fields) {
        action.payload.fields = mergeFields(fields);
      }

      const list = action.payload && action.payload.list ? action.payload.list : null;
      if (list) {
        const visibleFields = fields ? fields.filter(f => f.display === 1).map(f => f.name) : [];
        const fixDate = (row, name) => row[name] = row[name] === '0000-00-00' ? '' : row[name];

        list.forEach(e => {
          e['ss_no'] = format_ss_no(e['ss_no']),
          e['status'] = e['status'] === 'active' ? 'Active' : 'Inactive';
          e['absent'] = e['absent'] === 0 ? 'Yes' : 'No';
          e['state_id'] = e['state_id'] && e['state_id'] > 0 ? 
            countries.find(c => c.id === e['country_id'])
              .states.find(s => s.id === e['state_id']).name 
            : '';

          e['country_id'] = e['country_id'] > 0 ? countries.find(c => c.id === e['country_id']).name : '';

          fixDate(e, 'birthdate');
          fixDate(e, 'original_hire_date');
          fixDate(e, 'hire_date');
          fixDate(e, 'tenure_date');
          fixDate(e, 'last_worked_date'); 
          fixDate(e, 'last_check_date');
          fixDate(e, 'rehire_eligibility_date');
        });
      }
    };

    const fetch = () => {
      let ea;
      let countries;
      return d => Promise.all([
          fetchAllEmployees()(a => ea = a), 
          fetchCountries()(a => countries = a.payload.countries)])
        .then(() => {
          var res = ea.payload.list.filter(x => x['state_id'] && x['state_id'] > 0)
            .map(x => x['country_id'])
            .filter((value, index, self) => self.indexOf(value) === index)
            .map(x => fetchStates(x)(a => {
              countries.find(c => c.id === x).states = a.payload.states;
            }) );
          return Promise.all(res);
        })
        .then(() => ({ 
          employeesAction: ea, 
          countries: countries
        }));
    }

    return {
        list: () => {
          dispatch(fetch())
              .then(res => {
                parse(res.employeesAction, res.countries);
                return dispatch(res.employeesAction);
              })
        },
        moveToAdd: () => {
          dispatch(push('/pages/employee/add'));
        },
        moveToEdit: (id) => {
          dispatch(push('/pages/employee/' + id));
        },
        handleModalState: (data) => {
          dispatch(changeModalState(data));
        },
        handleObjectToDelete: (data) => {
          dispatch(deleteObject(data));
        }
    };
};  

export default connect(mapStateToProps, mapDispatchToProps)(Employees);



// WEBPACK FOOTER //
// ./src/containers/Employees/index.js